import { createSlice, type PayloadAction } from "@reduxjs/toolkit";

/**
 * Replaces the legacy `window.alert("An unknown error has occurred...")` calls
 * scattered through the Auto Order code. Mirrors the shape of
 * `vendorReviewToastSlice.ts` so it integrates with the existing
 * `<Toast />` component.
 *
 * Components dispatch `showAutoOrderToast({...})` from RTK Query failure paths;
 * `<Toast />` in the layout renders state and auto-dismisses.
 */

export type AutoOrderToastType = "success" | "error" | "info";

export interface AutoOrderToastState {
  showToast: boolean;
  toastMessage: string;
  toastSubMessage?: string;
  toastType: AutoOrderToastType;
  persistAcrossNavigation: boolean;
}

const initialState: AutoOrderToastState = {
  showToast: false,
  toastMessage: "",
  toastSubMessage: undefined,
  toastType: "error",
  persistAcrossNavigation: false,
};

export const autoOrderToastSlice = createSlice({
  name: "autoOrderToastSlice",
  initialState,
  reducers: {
    showAutoOrderToast: (
      state,
      action: PayloadAction<{
        toastMessage: string;
        toastSubMessage?: string;
        toastType?: AutoOrderToastType;
        persistAcrossNavigation?: boolean;
      }>,
    ) => {
      state.showToast = true;
      state.toastMessage = action.payload.toastMessage;
      state.toastSubMessage = action.payload.toastSubMessage;
      state.toastType = action.payload.toastType ?? "error";
      state.persistAcrossNavigation = action.payload.persistAcrossNavigation ?? false;
    },
    hideAutoOrderToast: (state) => {
      state.showToast = false;
    },
  },
});

export const { showAutoOrderToast, hideAutoOrderToast } = autoOrderToastSlice.actions;
export default autoOrderToastSlice;
